import React from 'react';
import { useCustomSection } from '../../hooks/useCustomSection';
import LoadSpinner from '../spinner';

const HtmlContent = ({ content }) => {
  return <div className='content' dangerouslySetInnerHTML={{ __html: content }} />;
};

const IframeContent = ({ src }) => {
  return (
    <iframe
      frameBorder='0'
      height='100%'
      src={src}
      style={{ overflow: 'hidden', height: '50rem', width: '100%' }}
      title='External link'
      width='100%'
    />
  );
};

const EmptyContent = ({ sectionName }) => (
  <div className='container pt-10 pb-10 w-screen'>
    <div className='text-center text-gray-500'>
      <p className='text-lg mb-2'>📝 Sección "{sectionName}" configurada</p>
      <p className='text-sm'>Esta sección no tiene contenido asignado aún.</p>
    </div>
  </div>
);

export const CustomSectionComp = ({ id }) => {
  const { raw, isHtmlContent, hasContent, sectionExists, contentUrl, isLoading, error } =
    useCustomSection(id);

  if (isLoading) {
    return (
      <div className='container pt-10 pb-10 w-screen flex justify-center'>
        <LoadSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className='container pt-10 pb-10 w-screen'>
        <div className='text-red-500 text-center'>
          Error al cargar la sección. Por favor, intenta nuevamente.
        </div>
      </div>
    );
  }

  if (!sectionExists) {
    return null;
  }

  if (!hasContent) {
    return <EmptyContent sectionName={raw.descripcion || `ID ${id}`} />;
  }

  return (
    <div className='container pt-10 pb-10 w-screen'>
      {isHtmlContent ? <HtmlContent content={raw.contenido} /> : <IframeContent src={contentUrl} />}
    </div>
  );
};
